window.$catalog_planning_pattern_result = [];
window.$catalog_planning_pattern_treeChangeStatus = false;
window.$catalog_planning_pattern_page_number = 1;
window.$catalog_planning_pattern_Glist = [];
window.$catalog_planning_pattern_selectedRow = [];
window.$catalog_planning_pattern_content = [];
window.$catalog_planning_pattern_algemeenNaam = [];
window.$catalog_planning_pattern_algemeenCode = [];
window.$catalog_planning_pattern_algemeenOmschrijving = [];
window.$catalog_planning_pattern_algemeenStatus = [];
window.$catalog_planning_pattern_scroll_change = false;
window.$catalog_planning_pattern_selectedIds = null;
window.$catalog_planning_pattern_column_list = null;
window.$catalog_planning_pattern_newInsertId = null;
window.$catalog_planning_pattern_gebruikers = null;
window.$catalog_planning_pattern_table_total_row_count = 0;
window.$catalog_planning_pattern_silederimages = [];
window.$catalog_planning_pattern_refresh = function (){};
window.$catalog_planning_pattern_columListPure = null;
window.$catalog_planning_pattern_lastUsedTableFilter = {
  content: [],
  definitions: [],
};
window.$catalog_planning_pattern_actions = [
  {
    id: "787cf96e-0c70-4b20-8e4c-2ac70224b82c",
    text: "Beheereenheid toevoegen",
    class: "locate",
    modal: "beheereenheid_toevoegen",
  },
  {
    id: "8c5da794-f8da-4549-9b48-f7123c59642a",
    text: "Plaats in map",
    class: "locate",
    modal: "modal_koppel_aan_folder",
  },
  {
    id: "df461440-0f13-40f8-a8c3-c8b2a6f7c4e8",
    text: "Toevoegen toezichthouder(s)",
    class: "locate",
    modal: "toevoegen_toezichthouder",
  },
  {
    id: "0f2c4cd8-bd15-48d9-b66b-6292ace8881f",
    text: "Selecteren directievoerder",
    class: "locate",
    modal: "selecteren_directievoerder",
  },
  {
    id: "c2c28e89-63ee-4714-8051-4b425f2c0976",
    text: "Toevoegen uitvoerder(s)",
    class: "locate",
    modal: "toevoegen_uitvoerder",
  },
];

window.$catalog_planning_pattern_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>planning-patroon",
        column_list: [
          "checkbox",
          "active",
          "Naam",
          "Code",
          "Omschrijving",
          "Starten Na",
          "Max Aantal",
          "Cyclus",
          "Planningsfrequentie",
          "Datum aangemaakt",
          "Datum laatst gewijzigd",
        ],
      },
    ],
  },
};
